module.exports = __webpack_public_path__ + "static/img/motorbike-yellow.4d551b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-yellow.svg
// module id = 1Zlo
// module chunks = 74